<template>
  <table class="regatta-table prop-table text-nowrap">
    <tr>
      <th>Аудитория</th>
      <td>{{ regatta.audience | getRegattaAudienceNameVerbose }}</td>
    </tr>
    <tr>
      <th>
        Минимальная<br>
        версия клиента
      </th>
      <td>{{ regatta.min_version | convertVersionCodeToStr }}</td>
    </tr>
    <tr>
      <th>Статус</th>
      <td>{{ regatta.status | statusName }}</td>
    </tr>
    <tr>
      <th>Создание</th>
      <td>{{ regatta.created_at | getMomentMinStr }}</td>
    </tr>
    <tr>
      <th>Начало</th>
      <td>{{ regatta.start_at | getMomentMinStr }}</td>
    </tr>
    <tr>
      <th>Начало реальное</th>
      <td>{{ regatta.actual_start_at | getMomentMinStr }}</td>
    </tr>
    <tr>
      <th>Конец</th>
      <td>{{ regatta.finish_at | getMomentMinStr }}</td>
    </tr>
    <tr>
      <th>Конец реальный</th>
      <td>{{ regatta.actual_finish_at | getMomentMinStr }}</td>
    </tr>

    <template v-if="isABTestVisible">
      <tr>
        <th>АБ тест</th>
        <td><code>{{ regatta.ab_test_id | getHumanProtoAlias }}</code></td>
      </tr>
      <tr>
        <th>Группа АБ-теста</th>
        <td>{{ regatta.ab_test_group }}</td>
      </tr>
    </template>

  </table>
</template>

<script>
import { getRegattaAudienceNameVerbose } from "@/model/regatta";
import { Regatta                       } from "@/model/regatta";

export default {
  name: 'RegattaTable',

  props: {
    regatta: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isABTestVisible() {
      const abTestId = this.regatta.ab_test_id;
      return Regatta.hasABTest(abTestId);
    },
  },

  filters: {
    getRegattaAudienceNameVerbose,
    statusName: Regatta.getStatusName,
  },
}
</script>

<style scoped>
.regatta-table > tr > td {
  vertical-align: top;
}
</style>
